<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<div class="home-screen">

  <life-di-nav></life-di-nav>
  <lifedi-breadcrumb></lifedi-breadcrumb>


  <div class="container">
    <h2 class="text-center lifedi-color" style="line-height: initial;">
      บริการให้คำแนะนำ/ปรึกษาปัญหาพัฒนาการทุกช่วงวัย
    </h2>
    <br />
    <form *ngIf="experties" [formGroup]="searchForm">
      <div class="row justify-content-center form-group">
        <div class="col-lg-2 col-md-12 col-form-label" style="display: inline;">
          <p class="text-label m-0"><b>ประเภท</b></p>
        </div>
        <div class="col-lg-5 col-md-12">
          <select class="custom-select form-control" id="type" style="display: inline;" formControlName="consultType"
            (change)="formChange()" (change)="setCategory(searchForm.value.consultType)">
            <option value="" selected disabled hidden>เลือกประเภท</option>
            <option value="Consult">Consult (ปรึกษา)</option>
            <option value="Intervention">Assessment & Intervention</option>
          </select>
        </div>
      </div>
      <div class="row justify-content-center form-group">
        <div class="col-lg-2 col-md-12 col-form-label" style="display: inline;">
          <p class="text-label m-0"><b>ประเด็นที่ต้องการปรึกษา</b></p>
        </div>
        <div class="col-lg-5 col-md-12">
          <select class="custom-select form-control" id="type" style="display: inline;" formControlName="expertie"
            (change)="formChange()">
            <option value="" selected disabled hidden>เลือกประเด็นที่ต้องการปรึกษา</option>
            <option *ngFor="let expertie of categoryList" [value]="expertie.EXPERTIE_ID">{{ expertie.EXPERTIE_NAME }}
            </option>
          </select>
        </div>
      </div>

      <div class="container mb-1" style="border: 1px #58595B solid; padding: 30px">
        <div class="form-group">
          <span style="padding-right: 15px;">วันที่</span>
          <input id="date" class="form-control" date-format="dd-MM-yyyy HH:mm:ss" formControlName="consultDate"
            [selectMode]="'range'" [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker" [rangeSeparator]="'-'"
            dateFormat="dd-MM-yyyy" autocomplete="off" style="width: 250px; display: inline;">
          <owl-date-time [pickerType]="'calendar'" #dtPicker></owl-date-time>
        </div>

        <div class="row justify-content-center">
          <lifedi-btn *ngIf="searchForm.valid" lable="ค้นหา" (click)="searching(searchForm.value)"
            customStyle="background-color: #A90088; color: #FFF; margin: 0px; padding: 0 30px;">
          </lifedi-btn>
          <lifedi-btn *ngIf="!searchForm.valid" disabled="true" lable="ค้นหา"
            customStyle="margin: 0px; padding: 0 30px;">
          </lifedi-btn>
        </div>

        <div *ngIf="allConsult">
          <div *ngIf="checkLength(allConsult['person']) > 0">
            <div class="strike mt-3 mb-3">
              <span style="line-height: 1.7;"><b>ส่วนตัว</b></span>
            </div>
            <div *ngFor="let consult of person; let i = index;">
              <h5><b>นักจิตวิทยา : {{ allConsult['person'][i].CONSULT_Instructor.USERNAME }}</b></h5>
              <div *ngFor="let list of consult | keyvalue; let j = index;">
                <p>วันที่ {{ list.key | date }}</p>
                <div class="row">
                  <div *ngFor="let item of list.value"
                    class="btn-group btn-group-toggle col-lg-2 col-md-3 col-sm-4 col-4" [(ngModel)]="ls"
                    [ngModelOptions]="{ standalone: true }" ngbRadioGroup>
                    <label *ngIf="item.CONSULT_STATUS === 'busy'" ngbButtonLabel class="btn-expertie"
                      style="margin-bottom: 20px;">
                      <input ngbButton type="radio" [value]="item"
                        (click)="getDetailDialog(item, allConsult['person'][i].CONSULT_Instructor, 'ส่วนตัว')"
                        ngbButton>
                      {{ getTime(item['CONSULT_DETAIL'].CONSULT_DATE_START) }} : 00 น.
                    </label>

                    <!-- เช็คว่า join + รอชำระเงิน + เช็คว่าประเภทที่จองไปแล้วตรงกับประเภทที่เลือก + เช็คหมวดที่จองไว้ตรงกับที่เลือก หรือไม่ -->
                    <label
                      *ngIf="item.CONSULT_STATUS === 'joined' && item.CONSULT_TYPE === searchForm.value.consultType &&
                      experties[searchForm.value.expertie - 1].EXPERTIE_NAME === item.CONSULT_CATEGORY &&
                      (item.STATUS_PAY === 'waiting_pay' || item.STATUS_PAY === 'waiting_confirm' || item.STATUS_PAY === 'reject')"
                      ngbButtonLabel class="btn-expertie" style="margin-bottom: 20px;">

                      <input ngbButton type="radio" [value]="item"
                        (click)="getDetailDialog(item, allConsult['person'][i].CONSULT_Instructor, 'ส่วนตัว')"
                        ngbButton>
                      {{ getTime(item['CONSULT_DETAIL'].CONSULT_DATE_START) }} : 00 น. <br />
                      <span *ngIf="item.STATUS_PAY === 'waiting_pay' || item.STATUS_PAY === 'reject'">รอชำระเงิน</span>
                      <span *ngIf="item.STATUS_PAY === 'waiting_confirm'">รอการยืนยันธุรกรรม</span>
                    </label>

                    <!-- เช็คว่า join + จ่ายเงิน ? หรือ join + เช็คว่าประเภทที่จองไปแล้วตรงกับประเภทที่เลือก หรือไม่ หรือ join + เช็คหมวดที่จองไว้ตรงกับที่เลือก หรือไม่-->
                    <label
                      *ngIf="(item.CONSULT_STATUS === 'joined' && (item.STATUS_PAY === 'success' || !item.STATUS_PAY)) ||
                      (item.CONSULT_STATUS === 'joined' && item.CONSULT_TYPE !== searchForm.value.consultType) ||
                      (item.CONSULT_STATUS === 'joined' && experties[searchForm.value.expertie - 1].EXPERTIE_NAME !== item.CONSULT_CATEGORY)"
                      ngbButtonLabel class="btn-expertie" style="margin-bottom: 20px;">

                      <input ngbButton type="radio" [value]="item" disabled="true" ngbButton>
                      {{ getTime(item['CONSULT_DETAIL'].CONSULT_DATE_START) }} : 00 น.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="checkLength(allConsult['group']) > 0">
            <div class="strike mt-3 mb-3">
              <span style="line-height: 1.7;"><b>ร่วมกับผู้อื่น</b></span>
            </div>
            <div *ngFor="let consult of group; let i = index;">
              <h5><b>นักจิตวิทยา : {{ allConsult['group'][i].CONSULT_Instructor.USERNAME }}</b></h5>
              <div *ngFor="let list of consult | keyvalue; let j = index;">
                <p>วันที่ {{ list.key | date }}</p>
                <div class="row">
                  <div *ngFor="let item of list.value"
                    class="btn-group btn-group-toggle col-lg-2 col-md-3 col-sm-4 col-4" [(ngModel)]="ls"
                    [ngModelOptions]="{ standalone: true }" ngbRadioGroup>
                    <label *ngIf="item.CONSULT_STATUS === 'busy'" ngbButtonLabel class="btn-expertie"
                      style="margin-bottom: 20px;">
                      <input ngbButton type="radio" [value]="item"
                        (click)="getDetailDialog(item, allConsult['group'][i].CONSULT_Instructor, 'ร่วมกับผู้อื่น')"
                        ngbButton>
                      {{ getTime(item['CONSULT_DETAIL'].CONSULT_DATE_START) }} : 00 น.
                    </label>

                    <!-- เช็คว่า join + รอชำระเงิน + เช็คว่าประเภทที่จองไปแล้วตรงกับประเภทที่เลือก + เช็คหมวดที่จองไว้ตรงกับที่เลือก หรือไม่ -->
                    <label
                      *ngIf="item.CONSULT_STATUS === 'joined' && item.CONSULT_TYPE === searchForm.value.consultType &&
                      experties[searchForm.value.expertie - 1].EXPERTIE_NAME === item.CONSULT_CATEGORY &&
                      (item.STATUS_PAY === 'waiting_pay' || item.STATUS_PAY === 'waiting_confirm' || item.STATUS_PAY === 'reject')"
                      ngbButtonLabel class="btn-expertie" style="margin-bottom: 20px;">

                      <input ngbButton type="radio" [value]="item"
                        (click)="getDetailDialog(item, allConsult['group'][i].CONSULT_Instructor, 'ร่วมกับผู้อื่น')"
                        ngbButton>
                      {{ getTime(item['CONSULT_DETAIL'].CONSULT_DATE_START) }} : 00 น. <br />
                      <span *ngIf="item.STATUS_PAY === 'waiting_pay' || item.STATUS_PAY === 'reject'">รอชำระเงิน</span>
                      <span *ngIf="item.STATUS_PAY === 'waiting_confirm'">รอการยืนยันธุรกรรม</span>
                    </label>

                    <!-- เช็คว่า join + จ่ายเงิน ? หรือ join + เช็คว่าประเภทที่จองไปแล้วตรงกับประเภทที่เลือก หรือไม่ หรือ join + เช็คหมวดที่จองไว้ตรงกับที่เลือก หรือไม่ -->
                    <label
                      *ngIf="(item.CONSULT_STATUS === 'joined' && (item.STATUS_PAY === 'success' || !item.STATUS_PAY)) ||
                      (item.CONSULT_STATUS === 'joined' && item.CONSULT_TYPE !== searchForm.value.consultType) ||
                      (item.CONSULT_STATUS === 'joined' && experties[searchForm.value.expertie - 1].EXPERTIE_NAME !== item.CONSULT_CATEGORY)"
                      ngbButtonLabel class="btn-expertie" style="margin-bottom: 20px;">

                      <input ngbButton type="radio" [value]="item" disabled="true" ngbButton>
                      {{ getTime(item['CONSULT_DETAIL'].CONSULT_DATE_START) }} : 00 น.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="checkLength(allConsult['group']) === 0 && checkLength(allConsult['person']) === 0"
            style="display: contents;">
            <div class=" col-12 text-center mt-4">
              <h3>ไม่พบกิจกรรม</h3>
            </div>
          </div>
        </div>
      </div> <br>
    </form>
  </div>

  <div class="mt-auto">
    <lifedi-footer *ngIf="experties"></lifedi-footer>
  </div>
</div>